import React from 'react';
import { Link } from 'react-router-dom';
import FreeCalculator from './FreeCalculator';
import { LegalFooter } from '../legal/LegalLinks';

export default function PublicCalculator() {
  return (
    <div className="min-h-screen bg-mono-base flex flex-col" data-testid="public-calculator-page">
      <header className="border-b border-mono-line bg-mono-base/95 backdrop-blur sticky top-0 z-40">
        <div className="max-w-5xl mx-auto px-4 md:px-8 h-14 flex items-center justify-between">
          <span className="text-white font-heading text-xs md:text-sm font-bold uppercase tracking-[0.25em]">
            Coach Rands Method
          </span>
          <Link
            to="/free"
            className="border border-crimson text-crimson hover:bg-crimson hover:text-white font-heading font-bold text-xs uppercase tracking-wider rounded-none px-4 py-2 transition-colors"
            data-testid="public-calc-start-free-btn"
          >
            Start free →
          </Link>
        </div>
      </header>
      <main className="flex-1 max-w-5xl w-full mx-auto px-4 md:px-8 py-8 md:py-12">
        <FreeCalculator publicMode />
      </main>
      <LegalFooter />
    </div>
  );
}
